
































































































































import { Component } from '@niknevis/vue-modules'

import Tooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import WebUserAuthCard from '@/modules/user/components/web/auth/WebUserAuthCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import AuthRoute from '@/modules/user/routes/auth.route'
import Copyright from '@/modules/shared/components/panel/Copyright.vue'
import Logo from '@/modules/shared/components/shared/Logo.vue'
import Vue from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { UserRegisterRequestModel } from '@/modules/user/models/user-request.model'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import { AuthService } from '@/modules/user/services/auth.service'


@Component({
  layout: WebLayout,
  metaInfo: {
    title: 'ثبت نام'
  },
  components: { Logo, Copyright, Checkbox, WebUserAuthCard, BaseCard, Heading, BaseInput, BaseButton, Tooltip }
})
export default class RegisterPage extends Vue {
  constructor(
    private readonly routes: AuthRoute,
    private readonly services: AuthService
  ) {
    super()
  }

  $refs!: {
    registerForm: QForm
  }

  //model = new RegisterSerializer()
  registerModel: UserRegisterRequestModel = {
    email: '',
    username: '',
    password: '',
    displayname: '',
    phone: ''
  }

  registerLoading = false

  register() {
    this.registerLoading = true
    this.$refs.registerForm.validate().then(success => {
      if (success) {
        this.services.register(this.registerModel).onFinish(() => {
          this.registerLoading = false
        })
      } else this.registerLoading = false
    })
  }
}
